import { render, staticRenderFns } from "./labelingManagement.vue?vue&type=template&id=0b8cba4e"
import script from "./labelingManagement.vue?vue&type=script&lang=js"
export * from "./labelingManagement.vue?vue&type=script&lang=js"
import style0 from "./labelingManagement.vue?vue&type=style&index=0&id=0b8cba4e&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8cba4e')) {
      api.createRecord('0b8cba4e', component.options)
    } else {
      api.reload('0b8cba4e', component.options)
    }
    module.hot.accept("./labelingManagement.vue?vue&type=template&id=0b8cba4e", function () {
      api.rerender('0b8cba4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/labelingManagement.vue"
export default component.exports